<template>
  <div v-if="store.state.userInfo">
    <navComponent
      :navStatus="navStatus"
      :navList="navList"
      @navSelect="navSelect"
      @changeNavStatus="changeNavStatus"
      @selectHome="selectHome"
    />
    <div
      class="content"
      :style="{
        width:
          !navStatus && router.currentRoute.value.path == '/'
            ? store.state.windowWidth - 238 + 'px'
            : !navStatus && router.currentRoute.value.path != '/'
            ? store.state.windowWidth - 220 + 'px'
            : store.state.windowWidth - 64 + 'px',
        marginLeft: !navStatus ? '220px' : '64px',
      }"
    >
      <topComponent
        :allNavList="allNavList"
        @searchChange="searchChange"
        :navStatus="navStatus"
        @getTree="getTree"
      />
      <div class="box">
        <div class="more">
          <el-popover
            placement="bottom"
            popper-class="home-popper"
            trigger="click"
            :width="100"
          >
            <p class="home-install-p" @click="closeTab('other')">
              {{ $t("topComponent.btn1") }}
            </p>
            <p class="home-install-p" @click="closeTab('all')">
              {{ $t("topComponent.btn2") }}
            </p>
            <template #reference>
              <el-button type="primary" size="small"
                >{{ $t("topComponent.btn3") }}
                <el-icon style="display: inline-block; margin-left: 5px"
                  ><ArrowDown
                /></el-icon>
              </el-button>
            </template>
          </el-popover>
        </div>
        <el-tabs
          class="nav-tabs"
          v-model="store.state.tabsValue"
          type="card"
          closable
          @tab-click="tabsClick"
          @tab-remove="tabsRemove"
          :style="{
            left: !navStatus ? '220px' : '64px',
          }"
        >
          <el-tab-pane
            v-for="(item, index) in store.state.tabsList"
            :key="index"
            :label="item.name"
            :name="item.path"
          >
          </el-tab-pane>
        </el-tabs>
        <div class="page">
          <router-view v-slot="{ Component, route }">
            <keep-alive :include="includeList">
              <component :is="Component" :key="route.name" />
            </keep-alive>
          </router-view>
          <!-- <template v-if="processEnv && processEnv.NODE_ENV != 'development'">
            <router-view v-slot="{ Component, route }">
              <keep-alive :include="includeList">
                <component :is="Component" :key="route.name" />
              </keep-alive>
            </router-view>
          </template>
          <template v-else><router-view> </router-view></template> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, reactive, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import Sortable from "sortablejs";
import { getStorage, removeStorage, setStorage } from "@/utils/storage";
import navComponent from "@/components/nav.vue";
import topComponent from "@/components/top.vue";
import i18n from "@/lang";
const { t } = i18n.global;
export default {
  props: {
    navList: null,
    allNavList: null,
  },
  components: {
    navComponent,
    topComponent,
  },
  setup(props, { emit }) {
    const route = useRoute();
    const router = useRouter();
    let includeList = reactive([]);
    const navStatus = ref(false);
    const store = useStore();
    const processEnv = reactive(process.env);
    const navList = props.navList;
    store.commit("SET_NAVLIST", navList);
    const allNavList = props.allNavList; //所有路由地址
    //tab集合
    let tabsList = getStorage("selectedTab")
      ? reactive(getStorage("selectedTab"))
      : reactive([
          { name: t("commonNav3"), index: "0", path: "/", code: "home" },
        ]);
    store.commit("SET_TABSLIST", tabsList);
    //页面内跳转fileList
    watch(
      () => store.state.gotoFileList,
      (newVal) => {
        if (newVal) {
          navList.map((item, index) => {
            if (item.code == "orders") {
              item.child.map((item1, index1) => {
                if (item1.code == "fileList") {
                  navSelect(index + "-" + index1);
                }
              });
            }
          });
        }
      }
    );
    //初始化需要缓存的tab
    tabsList.map((item) => {
      includeList.push(item.code);
    });
    //初始化tab
    let initTab = () => {
      if (
        router.currentRoute.value.path != "/" &&
        router.currentRoute.value.path != "/login"
      ) {
        let path = router.currentRoute.value.path;
        navList.map((item, index) => {
          item.child &&
            item.child.map((item1, index1) => {
              if (
                item1.child &&
                item1.child.length > 0 &&
                item1.child[0].category == 1
              ) {
                item1.child.map((item2, index2) => {
                  if (item2.path == path) {
                    //当前访问的url没有在tabslist中
                    if (includeList.indexOf(item2.code) < 0) {
                      tabsList.push(item2);
                      includeList.push(item2.code);
                    }
                    store.commit("SET_TABSVALUE", item2.path);
                    store.commit(
                      "SET_NAVVALUE",
                      index + "-" + index1 + "-" + index2
                    );
                    store.commit(
                      "SET_PAGEBTNLIST",
                      item2.child ? item2.child : null
                    );
                  }
                });
              } else {
                if (item1.path == path) {
                  //当前访问的url没有在tabslist中
                  if (includeList.indexOf(item1.code) < 0) {
                    tabsList.push(item1);
                    includeList.push(item1.code);
                  }
                  store.commit("SET_TABSVALUE", item1.path);
                  store.commit("SET_NAVVALUE", index + "-" + index1);
                  store.commit(
                    "SET_PAGEBTNLIST",
                    item1.child ? item1.child : null
                  );
                }
              }
            });
        });
      } else {
        store.commit("SET_TABSVALUE", "/");
        store.commit("SET_PAGEBTNLIST", null);
      }
    };
    initTab();
    //监听浏览器的前进后退按钮
    if (window.history && window.history.pushState) {
      window.addEventListener("popstate", initTab, false);
    }
    //点击导航条
    let navSelect = (index) => {
      let indexArr = index.split("-");
      let btn = false;
      let navCache =
        indexArr.length == 2
          ? navList[indexArr[0]].child[indexArr[1]]
          : navList[indexArr[0]].child[indexArr[1]].child[indexArr[2]];
      tabsList.map((item) => {
        if (item.path == navCache.path) {
          btn = true;
        }
      });
      //判断是否是页面内跳转fileList
      if (store.state.gotoFileList) {
        console.log(store.state.gotoFileList, "222");
        router.push({
          path: navCache.path,
          query: store.state.gotoFileList,
        });
        store.commit("SET_GOTOFILELIST", null);
      } else {
        router.push({
          path: navCache.path,
        });
      }

      if (!btn) {
        includeList.push(navCache.code);
        tabsList.push(navCache);
        store.commit("SET_TABSLIST", tabsList);
      }
      store.commit("SET_TABSVALUE", navCache.path);
      store.commit("SET_PAGEBTNLIST", navCache.child ? navCache.child : null);
      navList.map((item, index) => {
        item.child &&
          item.child.map((item1, index1) => {
            if (
              item1.child &&
              item1.child.length > 0 &&
              item1.child[0]["category"] == 1
            ) {
              item1.child.map((item2, index2) => {
                if (item2.path == navCache.path) {
                  if (index != navList.length - 1) {
                    store.commit(
                      "SET_NAVVALUE",
                      index + "-" + index1 + "-" + index2
                    );
                    store.commit(
                      "SET_PAGEBTNLIST",
                      item2.child ? item2.child : null
                    );
                  } else {
                    store.commit("SET_NAVVALUE", "0-0-0-0");
                    store.commit("SET_PAGEBTNLIST", null);
                  }
                }
              });
            } else {
              if (item1.path == navCache.path) {
                if (index != navList.length - 1) {
                  store.commit("SET_NAVVALUE", index + "-" + index1);
                  store.commit(
                    "SET_PAGEBTNLIST",
                    item1.child ? item1.child : null
                  );
                } else {
                  store.commit("SET_NAVVALUE", "0-0-0-0");
                  store.commit("SET_PAGEBTNLIST", null);
                }
              }
            }
          });
      });
    };
    //改变导航条状态
    let changeNavStatus = () => {
      navStatus.value = !navStatus.value;
    };
    //删除tab
    let tabsRemove = (targetName) => {
      tabsList.map((item, index) => {
        if (item.path == targetName) {
          includeList.splice(index, 1);
          tabsList.splice(index, 1);
          store.commit("SET_TABSLIST", tabsList);
          //删除的tab是当前选择的tab
          if (router.currentRoute.value.path == targetName) {
            //先重置不选中任何nav
            store.commit("SET_NAVVALUE", "0-0-0-0");
            store.commit("SET_TABSVALUE", tabsList[index - 1].path);

            router.push({
              path: tabsList[index - 1].path,
            });
            navList.map((item1, index1) => {
              item1.child.map((item2, index2) => {
                if (
                  item2.child &&
                  item2.child.length > 0 &&
                  item2.child[0]["category"] == 1
                ) {
                  item2.child.map((item3, index3) => {
                    if (item3.path == tabsList[index - 1].path) {
                      store.commit(
                        "SET_NAVVALUE",
                        index1 + "-" + index2 + "-" + index3
                      );
                      store.commit(
                        "SET_PAGEBTNLIST",
                        item3.child ? item3.child : null
                      );
                    }
                  });
                } else {
                  if (item2.path == tabsList[index - 1].path) {
                    store.commit("SET_NAVVALUE", index1 + "-" + index2);
                    store.commit(
                      "SET_PAGEBTNLIST",
                      item2.child ? item2.child : null
                    );
                  }
                }
              });
            });
          }
          return;
        }
      });
    };
    //点击tab
    let tabsClick = (tab) => {
      store.commit("SET_NAVVALUE", "0-0-0-0");
      navList.map((item, index) => {
        item.child &&
          item.child.map((item1, index1) => {
            if (
              item1.child &&
              item1.child.length > 0 &&
              item1.child[0]["category"] == 1
            ) {
              item1.child.map((item2, index2) => {
                if (item2.path == tab.props.name) {
                  if (index != navList.length - 1) {
                    store.commit(
                      "SET_NAVVALUE",
                      index + "-" + index1 + "-" + index2
                    );
                    store.commit(
                      "SET_PAGEBTNLIST",
                      item2.child ? item2.child : null
                    );
                  } else {
                    store.commit("SET_NAVVALUE", "0-0-0-0");
                    store.commit("SET_PAGEBTNLIST", null);
                  }
                }
              });
            } else {
              if (item1.path == tab.props.name) {
                if (index != navList.length - 1) {
                  store.commit("SET_NAVVALUE", index + "-" + index1);
                  store.commit(
                    "SET_PAGEBTNLIST",
                    item1.child ? item1.child : null
                  );
                } else {
                  store.commit("SET_NAVVALUE", "0-0-0-0");
                  store.commit("SET_PAGEBTNLIST", null);
                }
              }
            }
          });
      });
      router.push({
        path: tab.props.name,
      });
    };
    //路由搜索框
    let searchChange = (routeSearch) => {
      if (!routeSearch.value) return;
      let cashRoute = reactive({});
      navList.map((item, index) => {
        item.child &&
          item.child.map((item1, index1) => {
            if (
              item1.child &&
              item1.child.length &&
              item1.child[0]["category"] == 1
            ) {
              item1.child.map((item2, index2) => {
                if (item2.path == routeSearch.value) {
                  if (index != navList.length - 1) {
                    store.commit(
                      "SET_NAVVALUE",
                      index + "-" + index1 + "-" + index2
                    );
                    store.commit(
                      "SET_PAGEBTNLIST",
                      item2.child ? item2.child : null
                    );
                  } else {
                    store.commit("SET_NAVVALUE", "0-0-0-0");
                    store.commit("SET_PAGEBTNLIST", null);
                  }
                  cashRoute = item2;
                }
              });
            } else {
              if (item1.path == routeSearch.value) {
                if (index != navList.length - 1) {
                  store.commit("SET_NAVVALUE", index + "-" + index1);
                  store.commit(
                    "SET_PAGEBTNLIST",
                    item1.child ? item1.child : null
                  );
                } else {
                  store.commit("SET_NAVVALUE", "0-0-0-0");
                  store.commit("SET_PAGEBTNLIST", null);
                }
                cashRoute = item1;
              }
            }
          });
      });
      let btn = false;
      tabsList.map((item) => {
        if (item.path == routeSearch.value) {
          btn = true;
        }
      });
      if (!btn) {
        setTimeout(() => {
          tabsList.push(cashRoute);
          includeList.push(cashRoute.code);
          store.commit("SET_TABSLIST", tabsList);
        }, 100);
      }
      store.commit("SET_TABSVALUE", routeSearch.value);
      router.push({
        path: routeSearch.value,
      });
    };
    //关闭tab
    let closeTab = (type) => {
      if (type == "all") {
        tabsList = reactive([
          { name: t("commonNav3"), index: "0", path: "/", code: "home" },
        ]);
        store.commit(
          "SET_TABSLIST",
          reactive([
            { name: t("commonNav3"), index: "0", path: "/", code: "home" },
          ])
        );
        includeList = reactive([]);
        removeStorage({ name: "selectedTab" });
        selectHome();
      } else if (type == "other") {
        let tabsValue = store.state.tabsValue;
        for (let i = tabsList.length - 1; i >= 0; i--) {
          if (i != 0 && tabsList[i]["path"] != tabsValue) {
            tabsList.splice(i, 1);
            includeList.splice(i, 1);
          }
        }
        store.commit("SET_TABSLIST", tabsList);
      }
    };
    //拖拽方法
    let rowDrop = () => {
      const el = document.querySelector(".nav-tabs .el-tabs__nav");
      Sortable.create(el, {
        onEnd({ newIndex, oldIndex }) {
          store.commit("SET_TABSLIST", []);
          //oldIIndex拖放前的位置， newIndex拖放后的位置
          const currRow = tabsList.splice(oldIndex, 1)[0];
          if (newIndex == 0) newIndex = 1;
          tabsList.splice(newIndex, 0, currRow);
          setTimeout(() => {
            store.commit("SET_TABSLIST", tabsList);
          });
        },
      });
    };
    let selectHome = () => {
      store.commit("SET_TABSVALUE", "/");
      store.commit("SET_PAGEBTNLIST", null);
      store.commit("SET_NAVVALUE", "0-0-0-0");
      router.push({
        path: "/",
      });
    };
    let getTree = () => {
      closeTab("other");
      emit("getTree");
    };
    setTimeout(() => {
      rowDrop();
    }, 2000);
    return {
      navStatus,
      navList,
      allNavList,
      store,
      router,
      route,
      includeList,
      processEnv,
      selectHome,
      closeTab,
      navSelect,
      changeNavStatus,
      tabsRemove,
      tabsClick,
      searchChange,
      getTree,
    };
  },
};
</script>
<style lang="scss" scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.home {
  .nav {
    .iconfont {
      display: inline-block;
      margin-right: 5px;
    }
  }
  .content {
    background: #f0f2f5;
    .box {
      position: relative;
      margin-top: 65px;
      .more {
        position: fixed;
        right: 20px;
        z-index: 9;
        top: 70px;
      }
      .home-install {
        position: absolute;
        width: 70px;
        height: 40px;
        z-index: 3;
        cursor: pointer;
      }
      .nav-tabs {
        position: fixed;
        top: 65px;
        right: 0;
        z-index: 2;
        :deep(.el-tabs__header) {
          background: #fff !important;
          padding-right: 100px;
          margin-bottom: 10px;
        }
        :deep(.el-tabs__item) {
          color: #999;
          font-size: 13px;
          font-weight: normal;
        }
        :deep(.el-tabs__item.is-active) {
          color: #f6ca9d;
        }
        :deep(.el-tabs__content) {
          padding: 0;
        }
        :deep(.el-tabs__item:hover) {
          color: #f6ca9d;
        }
      }

      .page {
        padding: 20px;
        margin: 120px 10px 0;
        background: #fff;
      }
    }
  }
}
</style>
